/** What a member can join: a flight booking, on every leg, or an accommodation, as a guest. */
export type BookingKind = 'flight' | 'accommodation'

/**
 * Whether I'm on a flight booking or staying at an accommodation, and what its join
 * button says, as the detail page shows it. Ported from iOS `BookingMembership`.
 */
export interface BookingMembership {
	kind: BookingKind
	isJoined: boolean
}

export const bookingMembership = (kind: BookingKind, peopleIds: readonly number[], myUserId: number | undefined): BookingMembership => ({
	kind,
	isJoined: myUserId !== undefined && peopleIds.includes(myUserId),
})

export const membershipButtonTitle = ({ kind, isJoined }: BookingMembership): string => {
	if (kind === 'flight') return isJoined ? "You're on this flight ✓" : "I'm on this flight too"
	return isJoined ? "You're staying here ✓" : "I'm staying here"
}

/** Asked before the button takes me off. */
export const membershipLeaveTitle = ({ kind }: BookingMembership): string =>
	kind === 'flight' ? 'Leave this flight?' : 'Leave this accommodation?'

export const membershipLeaveMessage = ({ kind }: BookingMembership): string =>
	kind === 'flight' ? "You'll be taken off every leg of this flight." : "You'll be taken off its guests."

/** Who's on it, as the detail page heads them. */
export const membershipPeopleTitle = ({ kind }: BookingMembership): string =>
	kind === 'flight' ? 'Passengers' : 'Guests'

/** Said in place of the names when nobody is on it. */
export const membershipNobodyText = ({ kind }: BookingMembership): string =>
	kind === 'flight' ? 'No passengers yet' : 'No guests yet'
